export default __webpack_public_path__ + "c3085a69aaf668e82c2bd0427dfc8f37.svg";